import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { DashboardLayout } from '../layouts';
import { AccentButton } from '../components/Button';
import Modal from '../components/Modal';
import FolderItems from '../views/FolderItems';
import PastedItemView from '../views/PastedItemView';

import { useItems, useFolders } from '../../hooks/useFolder';
import { useClipboard } from '../../hooks/useClipboard';

const ItemsPage = () => {
  const navigate = useNavigate();

  const { folders } = useFolders();
  const { items, isLoading, createItem } = useItems(null);

  const [searchQuery, setSearchQuery] = useState('');
  const [activeMenuItem, setActiveMenuItem] = useState('items');
  const [isPasteOpen, setIsPasteOpen] = useState(false);
  const [pastedItems, setPastedItems] = useState([]);

  const folderOptions = folders.map(folder => ({
    value: folder.id,
    label: folder.name,
    color: 'rgba(74, 186, 98, 1)',
    fill: 'rgba(74, 186, 98, 0.2)',
  }));

  const handleAdd = (item) => {
    setIsPasteOpen(false);
    setPastedItems([]);
    createItem({ blob: item.blob, folderId: item.selectedFolderId });
  };

  const { handlePaste, clipboardRead } = useClipboard((items) => {
    setPastedItems(items);
    setIsPasteOpen(true);
  });

  useEffect(() => {
    document.addEventListener('paste', handlePaste);
    return () => document.removeEventListener('paste', handlePaste);
  }, [handlePaste]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white dark:bg-[#121212]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#121212] dark:border-[#D0D0D0]"></div>
      </div>
    );
  }

  return (
    <DashboardLayout
      activeMenuItem={activeMenuItem}
      onMenuItemClick={(item) => {
        setActiveMenuItem(item.id);
        if (item.id === 'dashboard') navigate('/my');
      }}
      searchQuery={searchQuery}
      onSearchChange={(e) => setSearchQuery(e.target.value)}
      onBackClick={() => navigate('/my')}
      onForwardClick={() => {}}
      onProfileClick={() => {}}
    >
      {/* Items Section Header */}
      <div className="border-b border-[#ECECEC] dark:border-[#202020] bg-white dark:bg-[#121212]">
        <div className="h-[70px] flex items-center justify-between px-6">
          <h2 className="text-xl font-medium text-[#121212] dark:text-[#D0D0D0]">
            All Items
          </h2>
          <div className="flex items-center gap-4">
            <AccentButton variant="primary" onClick={() => clipboardRead()}>Paste</AccentButton>
          </div>
        </div>
      </div>

      {/* Items Grid */}
      <div className="p-6">
        <FolderItems items={items} />
      </div>

      {/* Paste Content Modal */}
      <Modal isOpen={isPasteOpen} onClose={() => setIsPasteOpen(false)} size="xl">
        <PastedItemView
          pastedItems={pastedItems}
          onAdd={handleAdd}
          onCancel={() => setIsPasteOpen(false)}
          className="w-full h-full"
          folderOptions={folderOptions}
          defaultFolderId={folderOptions[0]?.value}
        />
      </Modal>
    </DashboardLayout>
  );
};

export default ItemsPage;
